<template>
  <with-actions>
    <div class="form-inline" slot="context-actions">
      <button class="btn btn-primary" @click="save">{{ 'save' | t }}</button>
    </div>
    <automations-form v-model="automation"></automations-form>
  </with-actions>
</template>
<script>
import _ from 'lodash';
import Api from '@/store/jsonapi';
import Alerts from '@/utils/alerts';

export default {
  props: ['automation_id'],
  data: function () {
    return {
      automation: null
    };
  },
  async mounted() {
    let o = this.setBreadcrumbs([
      { to: { name: 'automations' }, text: this.$t('routes_automations') },
      {
        to: { name: 'automation_create' },
        text: this.$t('routes_automation_edit')
      }
    ]);

    let { data } = await Api.find('automations', this.automation_id);

    this.automation = data;
  },
  methods: {
    save: async function () {
      await Api.update('automations', this.automation);
      this.$router.push({ name: 'automations' });
    }
  }
};
</script>

<style scoped></style>
